import { C_Regexp } from '@/ts/constants/C_Regexp';

import { removeCommas } from './removeCommas';

/**
 * Validates if input is a valid number with constraints
 * - Only allows numbers, one decimal point, and commas
 * - No negative signs, plus signs, or scientific notation
 * - First character cannot be a dot
 * - Maximum value: 999,999,999
 * - Minimum value: 0
 */
export function validateNumberInput(value: string): boolean {
  if (value === '') return true;

  if (value.startsWith('.')) return false;

  const validPattern = C_Regexp.numberWithOptionalDecimalAndCommas;
  if (!validPattern.test(value)) return false;

  const dotCount = (value.match(C_Regexp.dotGlobal) || []).length;
  if (dotCount > 1) return false;

  const numValue = parseFloat(removeCommas(value));
  if (isNaN(numValue)) return false;

  return numValue >= 0 && numValue <= 999999999;
}
